// This is the root-level index React thingy
// PLEASE DON'T ADD ANYTHING HERE
// My goal is to encapsulate into the App component, for the purposes of running tests
// -------------------------------
import React from "react";
import ReactDOM from "react-dom";

import "core-js/fn/array/includes";
import "core-js/fn/object/values";

// Enables caching and such (part of CRA default)
// https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API
// import registerServiceWorker from "./registerServiceWorker";

import App from "components/App";


ReactDOM.render(
      <App />,
    document.getElementById("root")
  );

// Because the user is in a captive webview, the user cannot initiate a page refresh,
// so the usefulness of this module is reduced.
//
// Additionally, this doesn't work on iOS devices, which cuts out like 50% of our targets.
// For consistency, disable the service worker
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js